import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";import { Toaster } from "@/components/ui/sonner";
import ConfirmProvider from "@/components/ConfirmProvider";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Trabajadores from "@/pages/Trabajadores";
import Seguimiento from "@/pages/Seguimiento";
import Recordatorios from "@/pages/Recordatorios";
import Reportes from "@/pages/Reportes";
import MandantesList from "@/pages/MandantesList";
import MandanteDetail from "@/pages/MandanteDetail";
import ContratoDetail from "@/pages/ContratoDetail";
import { AcreditacionList, AcreditacionMandante } from "@/pages/Acreditacion";
import AcreditacionContrato from "@/pages/AcreditacionContrato";
import AcreditacionTrabajadores from "@/pages/AcreditacionTrabajadores";
import AcreditacionTrabajadorDetail from "@/pages/AcreditacionTrabajadorDetail";
import Auditoria from "@/pages/Auditoria";
import Finiquitos from "@/pages/Finiquitos";
import Configuracion from "@/pages/Configuracion";
import Conversor from "@/pages/Conversor";
import Scanner from "@/pages/Scanner";
import WorkerPublic from "@/pages/WorkerPublic";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-slate-50"><Loader2 className="animate-spin text-slate-400" /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AuditGuard({ children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (!["ADMIN", "HR_MANAGER"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppShell() {
  const [search, setSearch] = useState("");
  return (
    <Layout search={search} setSearch={setSearch}>
      <Routes>
        <Route path="/" element={<Dashboard search={search} setSearch={setSearch} />} />
        <Route path="/trabajadores" element={<Trabajadores search={search} setSearch={setSearch} />} />
        <Route path="/seguimiento" element={<Seguimiento />} />
        <Route path="/recordatorios" element={<Recordatorios />} />
        <Route path="/reportes" element={<Reportes />} />
        <Route path="/mandantes" element={<MandantesList />} />
        <Route path="/mandantes/:id" element={<MandanteDetail />} />
        <Route path="/mandantes/:id/contratos/:cid" element={<ContratoDetail />} />
        <Route path="/acreditacion" element={<AcreditacionList />} />
        <Route path="/acreditacion/:id" element={<AcreditacionMandante />} />
        <Route path="/acreditacion/:id/contratos/:cid" element={<AcreditacionContrato />} />
        <Route path="/acreditacion/:id/contratos/:cid/trabajadores" element={<AcreditacionTrabajadores />} />
        <Route path="/acreditacion/:id/contratos/:cid/trabajadores/:wid" element={<AcreditacionTrabajadorDetail />} />
        <Route path="/trabajadores/:wid/ficha" element={<AcreditacionTrabajadorDetail />} />
        <Route path="/proyectos" element={<Navigate to="/mandantes" replace />} />
        <Route path="/conversor" element={<Conversor />} />
        <Route path="/auditoria" element={<AuditGuard><Auditoria /></AuditGuard>} />
        <Route path="/finiquitos" element={<Finiquitos />} />
        <Route path="/configuracion" element={<Configuracion />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/w/:id" element={<WorkerPublic />} />
      <Route path="/scanner" element={<Protected><Scanner /></Protected>} />
      <Route path="/*" element={<Protected><AppShell /></Protected>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ConfirmProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </ConfirmProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
